import { render } from "./Extra.vue?vue&type=template&id=45b8d684&scoped=true"
import script from "./Extra.vue?vue&type=script&lang=js"
export * from "./Extra.vue?vue&type=script&lang=js"

import "./Extra.vue?vue&type=style&index=0&id=45b8d684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b8d684"]])

export default __exports__